/**
 * Format an elapsed-seconds count as `Ns` or `Mm SSs`.
 *
 * @param seconds - Whole seconds elapsed.
 * @returns A short human-readable duration string.
 */
export function formatElapsed(seconds: number): string {
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  return `${minutes}m ${rest.toString().padStart(2, "0")}s`;
}
